中心仓<template>
  <div class="warp_contrainer">
    <div class="search_container">
      <div class="navCal">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="所有" name="first"></el-tab-pane>
          <el-tab-pane label="国内待入库" name="second"> </el-tab-pane>
          <el-tab-pane label="国内入库" name="third"></el-tab-pane>
          <el-tab-pane label="已合箱" name="6"></el-tab-pane>
          <el-tab-pane label="国内出库" name="four"></el-tab-pane>
          <el-tab-pane label="中心入库" name="7"></el-tab-pane>
          <el-tab-pane label="中心出库" name="8"></el-tab-pane>
          <el-tab-pane label="分舵入库" name="9"></el-tab-pane>
          <el-tab-pane label="客户签收" name="five"></el-tab-pane>
          <el-tab-pane label="已取消" name="six"></el-tab-pane>
          <el-tab-pane label="待补录" name="seven"></el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <el-form :inline="true" v-if="activeName != 8">
          <el-form-item label="">
            <el-input
              v-model="search.boxNumber"
              style="width: 150px"
              placeholder="合箱编码"
              clearable
              @clear="init()"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="search.vipCode"
              style="width: 130px"
              placeholder="用户VIP号"
              clearable
              @clear="init()"
            ></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="search.batchNum"
              style="width: 255px; padding-right: 6px"
              remote
              @change="batchChange"
              @clear="clearChecked"
              :remote-method="remoteMethod"
              reserve-keyword
              filterable
              :loading="loading"
              clearable
              placeholder="批次"
            >
              <el-option
                v-for="item in batchList"
                :key="item.sendId"
                :label="item.remark"
                :value="item.remark"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="search.deliveryTitle"
              style="width: 150px"
              @change="selectAddress"
              placeholder="派送点"
              clearable
              @clear="init()"
            >
              <el-option
                v-for="item in deliverArr"
                :key="item.addressId"
                :label="item.deliveryTitle"
                :value="item.deliveryTitle"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="search.goodType"
              placeholder="货物类型"
              @change="init()"
              style="width: 150px"
              clearable
              @clear="init()"
            >
              <el-option
                v-for="item in goodTypeSelect"
                :key="item.goodType"
                :label="item.goodName"
                :value="item.goodType"
              >
              </el-option>
            </el-select>
            <!-- 合箱时间筛选 -->
            <span class="search_lbl" style="margin-left: 10px">合箱时间：</span>
            <el-date-picker
              v-model="value1"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getDate(value1)"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <el-button style="margin-left: 10px" @click="init()" type="primary"
              >查询</el-button
            >
            <el-button
              style="margin-left: 10px"
              @click="exportToExcelBox()"
              type="primary"
              >导出箱</el-button
            >

            <!-- <el-button
              style="margin-left: 10px"
              @click="exportToExcel()"
              type="primary"
              >导出订单</el-button
            > -->

            <el-button
              style="margin-left: 10px"
              @click="exportOrderToExcel()"
              type="primary"
              >导出订单</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_container">
      <el-table
        :data="dataList"
        border
        style="width: 100%"
        row-key="boxId"
        ref="table"
        @selection-change="handleSelectionChange"
        stripe
      >
        <el-table-column
          type="selection"
          width="35"
          align="center"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
          prop="boxNumber"
          label="合箱编码"
          align="center"
          width="200px"
        >
          <template slot-scope="scope">
            <span
              class="boxTag"
              v-if="(scope.row.vipCodes || '').split(',').length > 1"
            >
              {{ (scope.row.vipCodes || "").split(",").length > 1 ? "混" : "" }}
            </span>
            {{ scope.row.boxNumber }}
          </template>
        </el-table-column>
        <el-table-column label="货物类型" align="center" width="100px">
          <template slot-scope="scope">
            <span>
              <span class="tag" v-if="scope.row.goodType == 1">{{
                goodType(scope.row.goodType)
              }}</span>
              <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                goodType(scope.row.goodType)
              }}</span>
              <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                goodType(scope.row.goodType)
              }}</span>
              {{ scope.row.goodName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="订单数量" align="center" width="80px">
          <template slot-scope="scope">
            {{ scope.row.orderCount }}
          </template>
        </el-table-column>
        <el-table-column label="用户VIP号" align="center" width="100px">
          <template slot-scope="scope">
            {{ scope.row.vipCodes }}
          </template>
        </el-table-column>
        <el-table-column
          label="批次"
          prop="batchNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="箱号"
          prop="boxNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column label="派送点" align="left" min-width="180px">
          <template slot-scope="scope">
            <div>
              <h5 v-for="(delivalue, indexs) in deliverArr" :key="indexs">
                <h5>
                  {{
                    delivalue.addressId === scope.row.addressId
                      ? delivalue.deliveryTitle
                      : ""
                  }}
                </h5>
              </h5>
            </div>
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="80px">
          已合箱
        </el-table-column>
        <el-table-column label="合箱时间" align="center" width="110px">
          <template slot-scope="scope">
            {{ toDate(scope.row.createTime, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220px">
          <template slot-scope="scope">
            <el-button type="text" @click="outHanlder(scope.row)"
              >出库</el-button
            >
            <el-button type="text" @click="viewHandler(scope.row)"
              >查看详情</el-button
            >
            <!-- <el-button type="text" @click="mianHandler(scope.row)">面单</el-button> -->
            <!-- <el-popconfirm
              title="您确认撤销吗？" @confirm="cancelBox(scope.row)" @onConfirm="cancelBox(scope.row)"> -->
            <el-button
              slot="reference"
              type="text"
              @click="cancelBox(scope.row)"
              >撤销</el-button
            >
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="footer">
        <div class="footer_left">
          <el-button type="primary" size="small" @click="outHanlder(null)"
            >批量出库</el-button
          >
          <el-button type="primary" size="small" @click="multiPrint"
            >批量打印</el-button
          >
        </div>
        <div class="footer_pagination">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 查看详情-->
    <el-dialog
      :visible.sync="viewDialog.show"
      :title="viewDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="900px"
      center
    >
      <div class="order_main">
        <div class="order_base">
          <div class="l_item">
            <span class="l_label">合箱编号：</span
            ><span class="l_value">X100000001</span>
            <span class="l_label">派送点：</span
            ><span class="l_value">Toronto</span>
            <span class="l_label">合箱时间：</span
            ><span class="l_value">2021-03-09 12:23:21</span>
          </div>
          <div class="l_item">
            <span class="l_label">订单状态：</span
            ><span class="l_value">待入库</span>
            <span class="l_label">订单数量：</span
            ><span class="l_value">2</span>
            <span class="l_label">预估费用：</span
            ><span class="l_value">CAD 19.88</span>
          </div>
          <div class="l_item">
            <span class="l_label">用户VIP号：</span
            ><span class="l_value">A100009</span>
          </div>
          <div class="l_item">
            <span class="l_label">货柜号：</span>
            <el-input style="width: 300px" placeholder="输入货柜号"></el-input>
            <span class="l_tip">（中转站签收可不填）</span>
          </div>
        </div>
        <div class="order_detail">
          <div class="title">
            <span class="name">商品清单</span>
            <div class="right">商品入库数据 （每件商品数据）</div>
          </div>
          <div class="product_list">
            <el-table
              :data="viewDialog.list"
              :show-header="false"
              border
              style="width: 100%"
              stripe
            >
              <el-table-column label="名称" min-width="200px" align="left">
                <template slot-scope="scope">
                  {{ scope.row.productName }}
                </template>
              </el-table-column>
              <el-table-column
                label="客户"
                prop="realName"
                min-width="70px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.realName }}
                </template>
              </el-table-column>
              <el-table-column
                label="vip号"
                prop="vipCode"
                min-width="60px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.vipCode }}
                </template>
              </el-table-column>
              <el-table-column
                label="物流公司"
                prop="expressCompany"
                min-width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="运单号"
                prop="expressNo"
                min-width="125px"
                align="left"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">提 交</el-button>
        <el-button @click="viewDialog.show = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="outDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>{{ outDialog.content }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="outSubmit()" v-if="outDialog.boxId"
          >确认</el-button
        >
        <el-button
          type="primary"
          @click="batchOutSubmit()"
          v-if="!outDialog.boxId"
          >确 定</el-button
        >
        <el-button type="default" @click="outDialog.show = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!--查看详情 -->
    <el-dialog
      :visible.sync="detailDialog.show"
      :title="detailDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1100px"
      center
    >
      <div class="order_main">
        <div class="order_base">
          <div class="l_item">
            <span class="l_label">合箱编号：</span
            ><span class="l_value">{{
              detailDialog.boxInfo ? detailDialog.boxInfo.boxNumber : ""
            }}</span>
            <span class="l_label">订单数量：</span
            ><span class="l_value">{{
              detailDialog.boxInfo ? detailDialog.boxInfo.deliveryTitle : ""
            }}</span>
            <span class="l_label">货物类型：</span
            ><span class="l_value">{{
              detailDialog.boxInfo
                ? goodType(detailDialog.boxInfo.goodType)
                : ""
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">用户VIP号：</span
            ><span class="l_value2">{{
              detailDialog.boxInfo ? detailDialog.boxInfo.vipCodes : ""
            }}</span>
          </div>
        </div>
        <div class="order_detail">
          <div class="product_list">
            <el-table
              :data="detailDialog.list"
              border
              style="width: 100%"
              stripe
            >
              <el-table-column label="名称" width="180px" align="left">
                <template slot-scope="scope">
                  {{ scope.row.productName }}
                </template>
              </el-table-column>
              <el-table-column
                label="货物类型"
                prop="goodType"
                min-width="90px"
                align="center"
              >
                <template slot-scope="scope">
                  <span>
                    <span class="tag" v-if="scope.row.goodType == 1">{{
                      goodType(scope.row.goodType)
                    }}</span>
                    <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                      goodType(scope.row.goodType)
                    }}</span>
                    <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                      goodType(scope.row.goodType)
                    }}</span>
                    {{ scope.row.goodName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="客户"
                prop="realName"
                min-width="70px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.realName }}
                </template>
              </el-table-column>
              <el-table-column
                label="vip号"
                prop="vipCode"
                min-width="80px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.vipCode }}
                </template>
              </el-table-column>
              <el-table-column
                label="物流公司"
                prop="expressCompany"
                min-width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="运单号"
                prop="expressNo"
                min-width="100px"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="商品价值"
                prop="predictTotal"
                width="80px"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="状态"
                prop="status"
                width="70px"
                align="left"
              >
                <template slot-scope="scope">
                  <span class="status1" v-if="scope.row.status == 1"
                    >待入库</span
                  >
                  <span class="status2" v-else-if="scope.row.status == 2"
                    >已入库</span
                  >
                  <span class="status3" v-else-if="scope.row.status == 3"
                    >已出库</span
                  >
                  <span class="status4" v-else-if="scope.row.status == 4"
                    >已结单</span
                  >
                  <span class="status-1" v-else-if="scope.row.status == -1"
                    >已取消</span
                  >
                  <span class="status7" v-else-if="scope.row.status == 6"
                    >已合箱</span
                  >
                  <span class="status7" v-else-if="scope.row.status == 7"
                    >(中心仓)已入库</span
                  >
                  <span class="status8" v-else-if="scope.row.status == 8"
                    >(中心仓)已出库</span
                  >
                  <span class="status9" v-else-if="scope.row.status == 9"
                    >(派送)已入库</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="运费(CAD)"
                prop="total"
                width="95px"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="下单时间"
                prop="addTime"
                width="100px"
                align="left"
              >
                <template slot-scope="scope">
                  {{ toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                label="派送点"
                prop="deliveryTitle"
                width="100px"
                align="left"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.show = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 面单-->
    <!-- <Face
      v-bind:boxId="faceOrderList"
      @closeFaceDialog="closeFaceDialog"
      v-if="mianDialog.show"
      :key="faceKey"
    ></Face> -->
        <Face
      v-bind:boxId="faceOrderList"
      @closeFaceDialog="closeFaceDialog"
      v-if="mianDialog.show"
    ></Face>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as deliveryApi from "@/api/delivery";
import { axios } from "utils/";
import * as date from "utils/date";
import * as StringUtils from "utils/StringUtils";
import * as unit from "utils/unit";
import * as order from "@/api/order";
import * as boxApi from "@/api/box";
import Face from "../components/face";
export default {
  components: {
    Face,
  },
  data() {
    return {
      multipleSelection: [],
      httpImg: "",
      activeName: "6",
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 20, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      search: {
        boxNumber: "",
        deliveryTitle: "",
        vipCode: "",
        goodType: null,
        batchNum: null,
      },
      dataList: [], //列表
      viewDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: null,
        list: [],
      },
      value1: "",
      startTime: "",
      endTime: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      detailDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: {},
        list: [],
      },
      outDialog: {
        show: false,
        boxId: null,
        content: "您是否将订单出库吗？该操作不可逆",
      },
      mianDialog: {
        show: false,
        title: "面单",
        width: "300",
        height: "260",
        boxId: null,
        boxInfo: {},
        list: [],
      },
      goodTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],

      addressSelect: [],
      columns: [
        // { title: "订单编号", key: "orderNo" },
        { title: "名称", key: "arrProduct" },
        { title: "货物类型", key: "goodNames" },
        { title: "客户", key: "realName" },
        { title: "vip号", key: "vipCode" },
        { title: "物流公司", key: "expressCompany" },
        { title: "运单号", key: "expressNo" },
        { title: "商品价值", key: "predictTotal" },
        { title: "状态", key: "dealStatus" },
        { title: "运费", key: "total" },
        { title: "下单时间", key: "addDate" },
        { title: "派送点", key: "deliveryTitle" },
        // { title: "联系方式", key: "tel" },
        // { title: "体积", key: "productVolume" },
        // { title: "重量", key: "productWeight" },
        // { title: "尺寸", key: "measure" },
        // { title: "所在箱", key: "boxNumber" },
        // { title: "合箱状态", key: "boxStatus" },
        // { title: "用户备注", key: "remark" },
        // { title: "订单备注", key: "sendRemark" },
      ],
      orderMoneyB: [],
      deliverArr: [],

      howManyTotal: 0,
      listArr: [],
      // 存放已合箱订单的打印数据
      OrderArr: [],
      columnsOrder: [
        { title: "箱编号", key: "boxNumber" },
        { title: "货物类型", key: "goodType" },
        { title: "订单数量", key: "orderCount" },
        { title: "用户VIP号", key: "vipCodes" },
        { title: "派送点", key: "address" },
        { title: "状态", key: "hxstatus" },
        { title: "合箱时间", key: "createTime" },
      ],
      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      loading: false,
      // 所有面单信息
      faceOrderList: [],
      faceKey: "",
      // 是否点击过打印按钮
      isHasClick:false,
    };
  },
  created() {
    let that = this;
    that.httpImg = process.env.IMG_URL;
    // that.mianDialog.width = unit.mmToPx(80);
    // that.mianDialog.height = unit.mmToPx(60);
    that.getBoxList();
    that.getDeliverById();
    this.getBatchList();
  },
  methods: {
    init() {
      this.paginations.page_index = 1;
      this.getBoxList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      this.faceOrderList = [];
      this.multipleSelection = val;
    },
    handleClick(tab, event) {
      let that = this;
      if (tab.name != "6") {
        that.$router.push("/orderList?activeName=" + tab.name);
        return;
      }
    },
    getBoxList() {
      let that = this;
      let param = {};
      param.pageIndex = that.paginations.page_index;
      param.pageSize = that.paginations.page_size;
      param.status = 0;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.startTime = that.startTime;
      param.endTime = that.endTime;
      param.batchNumber = that.search.batchNum
        ? that.search.batchNum.trim()
        : "";
      param.deliveryTitle = that.search.deliveryTitle;
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          that.howManyTotal = 0;
          that.getAllData();
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.dataList = res.data.data.list || [];
        that.paginations.total = res.data.data.pageCount;
        that.howManyTotal = res.data.data.pageCount;
        that.getAllData();
      });
    },
    viewHandler(row) {
      this.detailDialog.boxId = row.boxId;
      this.getDoxDetails();
      this.detailDialog.show = true;
    },
    getDoxDetails() {
      let that = this;
      let param = {};
      param.boxId = that.detailDialog.boxId;
      boxApi.boxDetails(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.detailDialog.boxInfo = res.data.data;
        that.detailDialog.list = res.data.data.orderPojoList || [];
      });
    },
    outHanlder(row) {
      //出库
      if (row != null) {
        this.outDialog.show = true;
        this.outDialog.boxId = row.boxId;
        this.outDialog.content = "您是否将订单出库吗？该操作不可逆";
      } else {
        if (
          this.multipleSelection == null ||
          this.multipleSelection.length == 0
        ) {
          this.$message.error("请选择");
          return;
        }
        this.outDialog.show = true;
        this.outDialog.boxId = null;
        this.outDialog.content = "您是否批量出库吗？该操作不可逆";
      }
    },
    outSubmit() {
      //出库提交
      let that = this;
      let param = {};
      param.boxId = that.outDialog.boxId;
      param.status = 3;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.boxDelivery(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "出库成功!",
          type: "success",
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },

    // 批量打印
    multiPrint() {
      this.isHasClick = true;
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length == 0
      ) {
        this.$message.warning("请选择");
        return;
      }
      // this.faceKey = !this.faceKey;

      let boxIdArr = [];
      for (const boxObj of this.multipleSelection) {
        boxIdArr.push(boxObj.boxId);
      }
      this.getFaceSheet(boxIdArr);
    },

    // 获取所有需要打印的面单的信息
    async getFaceSheet(boxIdArr) {
      let that = this;
      const loading = this.$loading({
          lock: true,
          text: '获取面单中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      let faceOrderList = [];
      
      for(let i = 0; i<boxIdArr.length;i++){
        let param = {
          boxId:boxIdArr[i]
        };
        
        await boxApi.faceSheet(param).then((res) => {
          if (res.data.code !== 0) {
            return that.$message.error(res.data.msg || "获取面单信息异常");
          }
          if (res.data.data) {
            faceOrderList.push(res.data.data);
            faceOrderList.map((itemObj) => {
              itemObj.faceImg = this.httpImg + itemObj.img;
              return itemObj;
            });
          }
        });
      }
      this.faceOrderList = faceOrderList;
      loading.close();
      this.mianDialog.show = true;
    },

    cancelBox(row) {
      let param = {};
      param.boxId = row.boxId;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.cancelBox(param).then((res) => {
        if (res.data.code != 0) {
          return this.$message.error(res.data.msg || "操作异常");
        }
        this.$message({
          message: "撤销成功!",
          type: "success",
        });
        this.getBoxList();
      });
      loading.close();
    },
    batchOutSubmit() {
      //批量出库
      let that = this;
      if (
        that.multipleSelection == null ||
        that.multipleSelection.length == 0
      ) {
        this.$message.error("请选择");
        return;
      }
      let param = {};
      param.status = 3;
      let boxPojos = [];
      that.multipleSelection.forEach((item) => {
        let obj = {};
        obj.boxId = item.boxId;
        obj.status = 3;
        boxPojos.push(obj);
      });
      param.boxPojos = boxPojos;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.volumeDelivery(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    getDate(value1) {
      if (!value1) {
        this.startTime = "";
        this.endTime = "";
        this.init();
        return;
      }
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime =
        new Date(mUtils.formatDate(value1[1])).getTime() + 86399000;
      this.init();
    },
    mianHandler(row) {
      this.mianDialog.show = true;
      this.mianDialog.boxId = row.boxId;
    },
    closeFaceDialog(val) {
      this.mianDialog.show = false;
      this.mianDialog.boxId = null;
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodType(goodType) {
      return StringUtils.goodType(goodType);
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      this.multipleSelection = [];
      this.faceOrderList = [];
      this.$refs.table.clearSelection();
      that.getBoxList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      this.multipleSelection = [];
      this.faceOrderList = [];
      this.$refs.table.clearSelection();
      that.getBoxList();
    },
    // async exportToExcel() {
    //   let that = this;
    //   let orderName = "";
    //   that.orderMoneyB = [];
    //   that.pagTotal = false;
    //   let nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);
    //   orderName = "已合箱订单" + nowTime;
    //   let pageTotal = 0;
    //   that.pageIndex = 0;
    //   let pageI = that.paginations.page_size;
    //   if (that.paginations.total) {
    //     pageTotal = that.paginations.total;
    //     const loading = this.$loading({
    //       lock: true,
    //       text: "loading",
    //       spinner: "el-icon-loading",
    //       background: "rgba(0, 0, 0, 0.7)",
    //     });
    //     if (pageTotal == 0) return;
    //     that.getOrderListB(pageTotal, function (val, pageCount) {
    //       that.orderMoneyB = that.orderMoneyB.concat(val);
    //       that.putDataToEx(that.columns, that.orderMoneyB, orderName);
    //     });
    //   }
    // },
    // 导出合箱的订单到excel
    exportOrderToExcel() {
      let that = this;
      this.getHowMangTotal();
    },

    // 获得所有条数 需要导出的数据
    async getHowMangTotal() {
      let that = this;
      let param = {
        pageIndex: 1,
        pageSize: 400,
      };

      param.status = 0;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.startTime = that.startTime;
      param.endTime = that.endTime;
      param.batchNumber = that.search.batchNum
        ? that.search.batchNum.trim()
        : "";
      param.deliveryTitle = that.search.deliveryTitle;

      let howManyPage = Math.ceil((that.howManyTotal * 1) / 400);

      let OrderArr = [];

      for (let i = 1; i <= howManyPage; i++) {
        param.pageIndex = i;
        await boxApi.boxList(param).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.list && res.data.data.list.length > 0) {
              res.data.data.list.forEach((detailPojo) => {
                if (
                  detailPojo.orderPojoList &&
                  detailPojo.orderPojoList.length > 0
                ) {
                  detailPojo.orderPojoList.map((everyPojo) => {
                    everyPojo.deliveryTitle = detailPojo.deliveryTitle;
                    everyPojo.vipCode = detailPojo.vipCodes;
                    everyPojo.boxNumber = detailPojo.boxNumber;
                    everyPojo.sendRemark = detailPojo.sendRemark;
                    everyPojo.goodNames =
                      that.goodTypeName(everyPojo.goodType) +
                      "-" +
                      everyPojo.goodName;
                    everyPojo.dealStatus = "已合箱";
                    everyPojo.addDate = mUtils
                      .formatDate(new Date(everyPojo.addTime))
                      .substring(0, 10);
                    OrderArr.push(everyPojo);
                  });
                }
              });

              // that.getAllData(res.data.data.pageCount);
            }
          }
        });
      }

      that.OrderArr = OrderArr;
      let orderName = "已合箱导出订单列表Excel";
      mUtils.export2Excel(that.columns, that.OrderArr, orderName);
    },
    // 写入Excel
    // async putDataToEx(columns, orderMoneyB, orderName) {
    //   await mUtils.export2Excel(columns, orderMoneyB, orderName);
    // },
    getOrderListB(page, callback) {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      // that.pagTotal=false
      let data = {
        // pageIndex: page,
        // pageSize: that.paginations.page_size,
        pageIndex: 1,
        pageSize: page,
        status: 6,
        // orderNo: that.orderNOA ? that.orderNOA : null,
        // startTime: that.startTime ? that.startTime : null,
        // endTime: that.endTime ? that.endTime : null,
        // userName: that.orderNOC ? that.orderNOC : null,
        // deliveryStartDate: that.deliveryStartDate && status==3 ? that.deliveryStartDate : null,
        // deliveryEndDate: that.deliveryEndDate && status==3 ? that.deliveryEndDate : null,
        // statementStartDate: that.statementStartDate && status==4 ? that.statementStartDate : null,
        // statementEndDate: that.statementEndDate && status==4 ? that.statementEndDate : null,
        // goodType: that.search.goodType ? that.search.goodType : null,
        // isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        // addressId:that.search.addressId
      };
      data.goodType = that.search.goodType;
      data.boxNumber = that.search.boxNumber;
      data.userName = that.search.vipCode;
      data.startTime = that.startTime;
      data.endTime = that.endTime;
      data.deliveryTitle = that.search.deliv;
      order.getOrderList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.dealStatus = "已合箱";
              val.goodName =
                that.goodTypeName(val.goodType) + "-" + val.goodName;
              if (val.remark) {
                val.remark = val.remark;
              }
              if (val.userRemark) {
                val.userRemark = val.userRemark;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure =
                  val.productLong +
                  "*" +
                  val.productWidth +
                  "*" +
                  val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils
                .formatDate(new Date(val.addTime))
                .substring(0, 10);
              if (
                val.detailList &&
                val.detailList.length > 0 &&
                val.detailList[0].productName.length > 20
              ) {
                if (val.detailList.length >= 2) {
                  val.productName =
                    val.detailList[0].productName.substring(0, 20) +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(
                    0,
                    20
                  );
                }
              } else {
                if (
                  val.detailList &&
                  val.detailList.length > 0 &&
                  val.detailList.length >= 2
                ) {
                  val.productName =
                    val.detailList[0].productName +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
                // val.productName=val.detailList[0].productName
              }
            });
            callback(res.data.data.list, res.data.data.pageCount);
          } else {
            that.orderMoneyB = that.orderMoneyB;
            callback([], res.data.data.pageCount);
          }
        } else {
          callback();
          that.$message.error("导出订单列表失败");
        }
        loading.close();
      });
    },
    goodTypeName(goodType) {
      let str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    getDeliverById() {
      let that = this;
      const type = 2;
      let param = {
        type,
      };
      deliveryApi.deliveryList(param).then((res) => {
        if (res.data.code !== 0) return;
        that.deliverArr = res.data.data.list;
      });
    },

    selectAddress(value) {
      let that = this;
      that.search.deliveryTitle = value;
    },

    // 导出合箱excel
    exportToExcelBox() {
      let that = this;
      let orderName = "合箱Excel";
      mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);
    },

    // 拿到所有导出的数据
    async getAllData() {
      let that = this;

      let param = {};
      param.pageIndex = 1;
      param.pageSize = 400;
      param.status = 0;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.startTime = that.startTime;
      param.endTime = that.endTime;
      param.batchNumber = that.search.batchNum
        ? that.search.batchNum.trim()
        : "";
      param.deliveryTitle = that.search.deliveryTitle;
      let howManyPage = Math.ceil((that.howManyTotal * 1) / 400);

      let listArr = [];
      for (let i = 1; i <= howManyPage; i++) {
        param.pageIndex = i;
        await boxApi.boxList(param).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.list) {
              res.data.data.list.map((every, index) => {
                every.createTime = mUtils
                  .formatDate(new Date(every.createTime))
                  .substring(0, 19);

                if (every.isHybrid) {
                  every.boxNumber += " 混";
                }
                every.hxstatus = "已合箱";

                if (every.goodType == 1) {
                  every.goodType = "海运";
                } else if (every.goodType == 2) {
                  every.goodType = "海运大件";
                } else if (every.goodType == 3) {
                  every.goodType = "空运";
                } else {
                  every.goodType = "";
                }

                listArr.push(every);
              });
            }
          }
        });
      }
      that.listArr = listArr;
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.init();
    },

    batchChange() {
      this.init();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },
  },
};
</script>
<style scoped lang="less">
.warp_contrainer {
  min-height: 100%;
  padding: 3px 20px 50px 20px;
}
.order_main {
  .order_base {
    margin-bottom: 20px;
    .l_item {
      padding: 6px 0;
      font-size: 12px;
      span {
        display: inline-block;
      }
      .l_label {
        width: 80px;
        text-align: right;
        font-weight: 600;
      }
      .l_value {
        width: 200px;
      }
    }
  }
  .order_detail {
    .title {
      padding-bottom: 10px;
      border-bottom: 1px solid #e1e1e1;
      .name {
        font-size: 15px;
        font-weight: bold;
      }
    }
    .product_list {
      margin-top: 10px;
    }
  }
  &.order_face {
    padding: 0 5px;
  }
  .order_header {
    padding-bottom: 3px;
    border-bottom: 1px solid #e1e1e1;
    .code_img {
      height: 40px;
      width: 100%;
    }
  }
  .order_box {
    padding: 5px 0;
    border-bottom: 1px solid #e1e1e1;
    span {
      font-size: 12px;
      display: inline-block;
    }
    .l_label {
      width: 60px;
    }
    .l_value {
      font-size: 12px;
    }
  }
  .order_address {
    padding: 5px 0;
    border-bottom: 1px solid #e1e1e1;
    .p1 {
      font-size: 12px;
    }
  }
  .order_detail {
    margin-top: 5px;
    font-size: 12px;
    .order_count {
      font-size: 12px;
      font-weight: bold;
    }
  }
  .product_list {
    .l_item {
      padding: 2px 0;
      font-size: 12px;
      .l_item_val {
        margin-right: 6px;
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
      }
      .l_name {
        font-size: 12px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .box_footer {
      margin-top: 5px;
      position: relative;
      span {
        display: inline-block;
      }
      .box_time {
        span {
          font-size: 12px;
          font-weight: bold;
        }
      }
      .box_type {
        position: absolute;
        right: 0;
        top: 0;
        span {
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
}
.footer {
  width: 100%;
  margin: 20px 0 50px 0;
  position: relative;
  .footer_pagination {
    position: absolute;
    right: 0;
    top: 0;
    left: 200px;
    margin-top: 0;
    text-align: right;
  }
}
.tag {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  &.tag1 {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2 {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3 {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
}
.boxTag {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 4px;
  background-color: #ffa500;
  border-color: #faecd8;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// boxOrderList.vue?06d98981